export default __webpack_public_path__ + "static/media/family-insurance-icon.be8a3d73.svg";